// import rouelles from "~/src/assets/paintings/view_at_rouelles.jpg";
import lunch from "~/src/assets/paintings/lunch_on_the_grass/pic.jpg";
import lunchNormal from "~/src/assets/paintings/lunch_on_the_grass/pic_normal.jpg";
import lunchThumb from "~/src/assets/paintings/lunch_on_the_grass/thumb.jpg";
import womenGarden from "~/src/assets/paintings/women_in_the_garden/pic.jpg";
import womenGardenNormal from "~/src/assets/paintings/women_in_the_garden/pic_normal.jpg";
import womenGardenThumb from "~/src/assets/paintings/women_in_the_garden/thumb.jpg";
import sainteAdresse from "~/src/assets/paintings/garden_at_sainte_adresse/pic.jpg";
import sainteAdresseNormal from "~/src/assets/paintings/garden_at_sainte_adresse/pic_normal.jpg";
import sainteAdresseThumb from "~/src/assets/paintings/garden_at_sainte_adresse/thumb.jpg";
import womanGarden from "~/src/assets/paintings/dama_v_sadu/pic.jpg";
import womanGardenNormal from "~/src/assets/paintings/dama_v_sadu/pic_normal.jpg";
import womanGardenThumb from "~/src/assets/paintings/dama_v_sadu/thumb.jpg";
import magpie from "~/src/assets/paintings/magpie/pic.jpg";
import magpieNormal from "~/src/assets/paintings/magpie/pic_normal.jpg";
import magpieThumb from "~/src/assets/paintings/magpie/thumb.jpg";
import grenouillere from "~/src/assets/paintings/grenouillere/pic.jpg";
import grenouillereNormal from "~/src/assets/paintings/grenouillere/pic_normal.jpg";
import grenouillereThumb from "~/src/assets/paintings/grenouillere/thumb.jpg";
import springTime from "~/src/assets/paintings/springtime/pic.jpg";
import springTimeNormal from "~/src/assets/paintings/springtime/pic_normal.jpg";
import springTimeThumb from "~/src/assets/paintings/springtime/thumb.jpg";
import tulipField from "~/src/assets/paintings/tulip_field/pic.jpg";
import tulipFieldNormal from "~/src/assets/paintings/tulip_field/pic_normal.jpg";
import tulipFieldThumb from "~/src/assets/paintings/tulip_field/thumb.jpg";
import impression from "~/src/assets/paintings/impression/pic.jpg";
import impressionNormal from "~/src/assets/paintings/impression/pic_normal.jpg";
import impressionThumb from "~/src/assets/paintings/impression/thumb.jpg";
import grainstacksThumb from "~/src/assets/paintings/grainstacks/thumb.jpg";
import grainstacks from "~/src/assets/paintings/grainstacks/pic.jpg";
import grainstacksNormal from "~/src/assets/paintings/grainstacks/pic_normal.jpg";
import maki from "~/src/assets/paintings/maki/pic.jpg";
import makiNormal from "~/src/assets/paintings/maki/pic_normal.jpg";
import makiThumb from "~/src/assets/paintings/maki/thumb.jpg";
import parliament from "~/src/assets/paintings/parliament/pic.jpg";
import parliamentNormal from "~/src/assets/paintings/parliament/pic_normal.jpg";
import parliamentThumb from "~/src/assets/paintings/parliament/thumb.jpg";
import waterLilies from "~/src/assets/paintings/water_lilies/pic.jpg";
import waterLiliesNormal from "~/src/assets/paintings/water_lilies/pic_normal.jpg";
import waterLiliesThumb from "~/src/assets/paintings/water_lilies/thumb.jpg";
// import kuvshinki from "~/src/assets/paintings/kuvshinki/pic.jpg";
// import kuvshinkiNormal from "~/src/assets/paintings/kuvshinki/pic_normal.jpg";
// import kuvshinkiThumb from "~/src/assets/paintings/kuvshinki/thumb.jpg";
import parasol from "~/src/assets/paintings/woman_parasol/pic.jpg";
import parasolNormal from "~/src/assets/paintings/woman_parasol/pic_normal.jpg";
import parasolThumb from "~/src/assets/paintings/woman_parasol/thumb.jpg";
import sanGiorgio from "~/src/assets/paintings/san_giorgio/pic.jpg";
import sanGiorgioNormal from "~/src/assets/paintings/san_giorgio/pic_normal.jpg";
import sanGiorgioThumb from "~/src/assets/paintings/san_giorgio/thumb.jpg";

export type TPaintingData = {
  title: string;
  thumb: string;
  year: string;
  file: string;
  normal: string;
  key: string;
};

export const paintingsData: TPaintingData[] = [
  // 0
  //  {
  //		key: 'rouelles',
  //    title: "Вид на Руэль",
  //    year: "1858",
  //    file: rouelles,
  //    desc: "Первая известная картина Моне, написанная под влиянием его учителя - Эжена Будена",
  //  },
  // 1
  {
    key: "lunch",
    title: "Luncheon on the Grass",
    year: "1866",
    file: lunch,
    thumb: lunchThumb,
    normal: lunchNormal,
  },
  {
    key: "womenGarden",
    title: " Women in the Garden",
    year: "1866",
    file: womenGarden,
    thumb: womenGardenThumb,
    normal: womenGardenNormal,
  },
  {
    key: "sainteAdresse",
    title: "Garden at Sainte-Adresse",
    year: "1867",
    file: sainteAdresse,
    thumb: sainteAdresseThumb,
    normal: sainteAdresseNormal,
  },
  {
    key: "womanGarden",
    title: "Woman in the Garden",
    year: "1867",
    file: womanGarden,
    thumb: womanGardenThumb,
    normal: womanGardenNormal,
  },
  // 2
  {
    key: "mapgie",
    title: "The Magpie",
    year: "1868-1869",
    file: magpie,
    thumb: magpieThumb,
    normal: magpieNormal,
  },
  {
    key: "gren",
    title: "La Grenouillere",
    year: "1869",
    file: grenouillere,
    thumb: grenouillereThumb,
    normal: grenouillereNormal,
  },
  {
    key: "spring",
    title: "Springtime",
    year: "1872",
    thumb: springTimeThumb,
    normal: springTimeNormal,
    file: springTime,
  },
  {
    key: "impression",
    title: "Impression, Sunrise",
    year: "1872",
    file: impression,
    thumb: impressionThumb,
    normal: impressionNormal,
  },
  {
    key: "maki",
    title: "Poppy Field",
    year: "1873",
    file: maki,
    thumb: makiThumb,
    normal: makiNormal,
  },
  {
    key: "parasol",
    title: "Woman with a Parasol",
    year: "1875",
    file: parasol,
    thumb: parasolThumb,
    normal: parasolNormal,
  },
  // 3
  {
    key: "tulip",
    title: "Tulip Fields",
    year: "1886",
    file: tulipField,
    thumb: tulipFieldThumb,
    normal: tulipFieldNormal,
  },
  {
    key: "grain",
    title: "Meules",
    year: "1891",
    file: grainstacks,
    thumb: grainstacksThumb,
    normal: grainstacksNormal,
  },
  {
    key: "parl",
    title: "The Houses of Parliament",
    year: "1903-1904",
    file: parliament,
    thumb: parliamentThumb,
    normal: parliamentNormal,
  },
  {
    key: "sanGiorgio",
    title: "San Giorgio Maggiore at Dusk",
    year: "1908-1912",
    file: sanGiorgio,
    thumb: sanGiorgioThumb,
    normal: sanGiorgioNormal,
  },
  {
    key: "lilies",
    title: "Water Lilies",
    year: "1915",
    file: waterLilies,
    thumb: waterLiliesThumb,
    normal: waterLiliesNormal,
  },
  // {
  //   key: "kuvshinki",
  //   title: "Кувшинки",
  //   year: "1914-1917",
  //   file: kuvshinki,
  //   thumb: kuvshinkiThumb,
  //   normal: kuvshinkiNormal,
  // },
];
